/*
	MUTATIONS
*/
//------------------------------------------------------------
// SHOW SYSTEM
//------------------------------------------------------------

const SHOW_SYSTEM = (state, bool) => {
    state.showSystem = bool;
}

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	SHOW_SYSTEM
}
//===========================================
//
//===========================================